import React, { useEffect, useRef, useState } from 'react';
import { Checkbox, Input } from 'antd';
import { section } from '../../types/types';
import InfoCard from './infoCard';
import { countProperties } from "../../utils/utils";
import { GetRequest } from '../../utils/api';
import styles from "./infoCard.module.scss";
import CustomLoader from '../../components/loader';

interface Props {
  urlparams: Map<string, string>;
  bluprintSections: section[];
  sectionsBlueprintApis?: string[];
  viewHideEmptyFields: boolean;
  showSearch?: boolean;
}

const RelatedInfo: React.FC<Props> = ({
  urlparams,
  bluprintSections: sections,
  sectionsBlueprintApis: sectionsApi,
  viewHideEmptyFields,
  showSearch = false,
}) => {



  const allSections = useRef(sections);
  const pinnedSections = useRef<section[]>();
  const unPinnedSections = useRef<section[]>();

  const [showEmpty, setShowEmpty] = useState<boolean>(viewHideEmptyFields);
  const [errorMessages, setErrorMessages] = useState<Map<string, string>>(new Map());
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [sectionFieldValues, setSectionFieldValues] = useState<any>();

  // let apiURLs: Map<string, string[]> = new Map();
  let sectionData: Map<string, any> = new Map();

  // Function to update the error messages
  const updateErrorMessages = (sectionName: string, error: string) => {
    // errorMessages.set(sectionName, error);
  };

  const [pinned, setPinned] = useState<string[]>(() => {
    const p = localStorage.getItem("pinnedInfoCards");
    return p ? JSON.parse(p) : [];
  });

  useEffect(() => {

    setIsLoading(true);
    getSections();

  }, []);

  const handleSectionApis = () => {

    let apiURLs: Map<string, string[]> = new Map();

    allSections.current.forEach((item) => {

      let actualApi = item.api;
      
      urlparams.forEach((value, key) => {
        
        if (actualApi.includes("{" + key + "}") && (value === "" || value === undefined || value === null)) {
          actualApi = "";
        }

        actualApi = actualApi?.replace("{" + key + "}", value);
      
      });

      item.api = actualApi;

      const existingSections: string[] = apiURLs.get(actualApi) ?? [];
      apiURLs.set(actualApi, [...existingSections, item.sectionName]);

    });

    apiURLs = new Map(apiURLs);
    return apiURLs;

  };


  const handleSectionPinnedStatus = () => {

    const pCards:section[] = [];
    const uPCards:section[] = [];

    allSections.current.forEach((item) => {

      if (pinned.includes(item.sectionName)) {
        item.isPinned = true;
        pCards.push(item);
    
      } else {
        item.isPinned = false;
        uPCards.push(item);
      }

    });

    unPinnedSections.current = uPCards;
    pinnedSections.current = pCards;

  }

  const getSections = async () => {


    if (sectionsApi && sectionsApi?.length > 0) {

      await Promise.all(sectionsApi.map((url) => {
        
        return GetRequest(url).then((res) => {
          
          if (Array.isArray(res) && res.length > 0) {
            sections = [...sections, ...res];
          }

        });

      }));

    }

    allSections.current = sections;
    handleSectionPinnedStatus();

   await getSectionData();
  
  }


  const getSectionData = async () => {

        // Call handleSectionApis after the Promise.all is completed
        const apiURLs = handleSectionApis();
    
        await Promise.all([...apiURLs.keys()].filter((url: string) => url !== "" && url !== null && url !== undefined)
          .map((url: string) =>
            GetRequest(url).then((data: any) => {
    
              let singleRecord;
    
              if (data.hasOwnProperty('records')) {
                singleRecord = data.records;
              } else {
                singleRecord = [];
                singleRecord.push(data);
              }
    
              let { totalProperties, nullProperties } = countProperties(singleRecord);
    
              if (totalProperties === nullProperties) {
                sectionData.set(url, false);
              } else {
                sectionData.set(url, singleRecord);
              }
    
            }).catch((error: Error) => {
              apiURLs.get(url)?.forEach((sectionName: string) => {
                updateErrorMessages(sectionName, error.message);
              });
            })
    
          )).then(() => {
            setSectionFieldValues(sectionData);
            setIsLoading(false);

          });
    
  }



  useEffect(() => {
    handleSectionPinnedStatus();
    // Force re-render by updating the state
    setSectionFieldValues(new Map(sectionFieldValues));
  }, [pinned]);


  //Search Feature
  const searchGrid = useRef<any>();

  const onSearch = (str: string) => {
    const divs: HTMLDivElement[] = searchGrid.current.getElementsByClassName("info-card");

    for (const card of divs) {
      if (!card.textContent?.toLowerCase()?.includes(str.toLowerCase())) {
        card.classList.add("d-none");
      } else {
        card.classList.remove("d-none");
      }
    }
  }

  //Pinning Feature
  const updatePinned = (sectionName: string) => {

    setPinned((prevPinned) => {

      let newPinned;

      if (prevPinned.includes(sectionName)) {
        newPinned = prevPinned.filter((item) => item !== sectionName);
      } else {
        newPinned = [...prevPinned, sectionName];
      }

      localStorage.setItem("pinnedInfoCards", JSON.stringify(newPinned));
      return newPinned;

    });
  };


  return (
    <>
      {<div className='justify-content-end' >
        
        {showSearch && (<div className='mr-2' style={{ width: "180px" }}>
          <Input placeholder='Search ...' allowClear={true} onChange={(ev) => onSearch(ev.target.value)} ></Input>
        </div>)}

        <div className='pt-2'> {viewHideEmptyFields && <Checkbox className='mr-3' onChange={() => { setShowEmpty(!showEmpty) }}>Hide blank fields</Checkbox>}</div>
      
      </div>}

      {!isLoading && (
        <div ref={searchGrid}>
          <div className={styles.cardGrid + " my-2"}>
            <>

              {pinnedSections.current?.map((section, index) => {

                if (sectionFieldValues.get(section.api) && sectionFieldValues.get(section.api).length > 0) {
                  return (<div className={"info-card " + styles.gridItem}>
                    <InfoCard breakGrid={sectionFieldValues.size === 1} pinned={() => updatePinned(section?.sectionName)} key={index} sectionFieldValues={sectionFieldValues.get(section.api) ?? []} showEmpty={showEmpty} header={section?.sectionName} urlparams={urlparams} section={section} apiError={errorMessages.get(section.sectionName)} enablePin={allSections.current.length > 2} />
                  </div>)
                } else {
                  return <></>
                }

              })}
            </>

          </div>

          <div className={(unPinnedSections.current?.length === 1 ? "" : styles.cardGrid)}>
              <>
                {unPinnedSections.current?.map((section, index) => {

                  if (sectionFieldValues.get(section.api) && sectionFieldValues.get(section.api).length > 0) {
                    return (<div className={"info-card " + styles.gridItem}>
                      <InfoCard   breakGrid={sectionFieldValues.size === 1} pinned={() => updatePinned(section?.sectionName)} key={index} sectionFieldValues={sectionFieldValues.get(section.api) ?? []} showEmpty={showEmpty} header={section?.sectionName} urlparams={urlparams} section={section} apiError={errorMessages.get(section.sectionName)} enablePin={allSections.current.length > 2} />
                    </div>)
                  } else {
                    return <></>
                  }
                })}
              </>

          </div>
        </div>
      )}

      {isLoading && <div className="text-center py-5"> <CustomLoader size="lg"></CustomLoader> </div>}

    </>
  );
};


export default RelatedInfo;
